import { useState } from "react";

const faqs = [
  {
    question: "Czym jest Kakobuy Spreadsheet?",
    answer:
      "Kakobuy Spreadsheet to zorganizowana baza produktów z Chin z gotowymi linkami, zdjęciami QC i informacjami o cenach. Dzięki niej nie musisz przeszukiwać setek stron — wszystkie najlepsze produkty są w jednym miejscu, posegregowane według kategorii.",
  },
  {
    question: "Czy Kakobuy Spreadsheet jest darmowy?",
    answer:
      "Tak, dostęp do podstawowej bazy produktów Kakobuy Spreadsheet jest całkowicie darmowy. Możesz przeglądać kategorie, linki i produkty bez żadnych opłat.",
  },
  {
    question: "Jak często aktualizowana jest baza produktów?",
    answer:
      "Baza produktów jest aktualizowana regularnie, zazwyczaj kilka razy w tygodniu. Nowe produkty pojawiają się wraz z nowymi znaleziskami społeczności Kakobuy, a stare linki są weryfikowane i usuwane, jeśli przestają działać.",
  },
  {
    question: "Czy zakupy na Kakobuy są bezpieczne?",
    answer:
      "Tak, Kakobuy to sprawdzona platforma agentska działająca od lat. W naszym przewodniku znajdziesz wskazówki jak unikać oszustw, sprawdzać sprzedawców i robić bezpieczne zakupy. Zalecamy zawsze sprawdzać QC zdjęcia przed zatwierdzeniem wysyłki.",
  },
  {
    question: "Jak długo trwa wysyłka do Polski?",
    answer:
      "Wysyłka do Polski zazwyczaj trwa od 10 do 25 dni roboczych w zależności od wybranej linii wysyłkowej. DHL i EMS są szybsze (10-15 dni), podczas gdy tańsze opcje mogą zająć do 25 dni.",
  },
  {
    question: "Co to są QC zdjęcia i dlaczego są ważne?",
    answer:
      "QC (Quality Control) to zdjęcia produktów wykonane przez magazyn Kakobuy po dostarczeniu zamówienia. Pokazują one rzeczywisty wygląd produktu, umożliwiając weryfikację jakości przed wysyłką do Ciebie. To kluczowy krok w procesie zakupowym.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Najczęściej zadawane pytania
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Odpowiedzi na najpopularniejsze pytania o Kakobuy Spreadsheet
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-add-line text-lg text-primary-500 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? "rotate-45" : ""}`}
                />
              </button>
              <div
                className={`px-5 overflow-hidden transition-all duration-300 ease-out ${openIndex === i ? "max-h-96 pb-5" : "max-h-0"}`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA after FAQ */}
        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-base font-semibold px-8 py-3.5 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Uzyskaj dostęp do pełnego Kakobuy Spreadsheet
            <i className="ri-external-link-line" />
          </a>
        </div>
      </div>
    </section>
  );
}